import Reflux from 'reflux';

import EventData from 'shared/data/Event';

const async = { asyncResult: true },
  EventViewActions = Reflux.createActions({
    populate: async,
    populateForGuest: async,
    populateGlobalElementManager: async,
  });

EventViewActions.populate.listenAndPromise(EventData.get);

EventViewActions.populateForGuest.listenAndPromise(EventData.getForGuest);

EventViewActions.populateGlobalElementManager.listenAndPromise(
  EventData.getGlobalElementManager,
);

export default EventViewActions;
